import React, { useState } from 'react';
import './VerifyPopUp.css';
import { Modal } from 'react-bootstrap';
import Button from '../Button';
import CrossSVG from './../../../assets/svg_main/CrossIcon.svg'

type VerifyModalProps = {
  className?:string;
  title?:string;
  closeVerifyModal:()=>void;
  contents: React.ReactNode;

};

const DynamicVerifyModal = ({
    className,
    title,
    closeVerifyModal,
    contents
}: VerifyModalProps) => {
    const [show, setShow] = useState<boolean>(true);
    const handleClose = () => setShow(false);

  return (
    <div className={`custom_verify_modal_container ${className}`}>
       <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom_modal_verify"
      >
        <Modal.Header className="custom_modal_verify_header">
         
            <div className="custom_verify_modal_title">{title}</div>
            <div className='custom_modal_verify_button_cross'>
            <Button
              onClick={closeVerifyModal}
              disabled={false}
              id="custom_modal_verify_button_cross"
              buttonName={''}
              colorType={'previous'}
              icon={<CrossSVG/>}
              iconPosition={'left'}
            />
            </div>
         
         
        </Modal.Header>
        <Modal.Body className="verify_modal_body">
        {contents}
        </Modal.Body>
      
      </Modal>
    </div>
  );
};

export default DynamicVerifyModal;
